"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAttachmentRateLimitPropertySchema = exports.isDocxColumnConfigs = exports.isDocxColumnConfig = exports.isDocxFileInsertionOutputs = exports.isAthenaConfigQueries = exports.isAthenaConfigQuery = exports.isAthenaConfigRecurringQueries = exports.isAthenaConfigRecurringQuery = exports.isDeliverableArtifactPropertyConfig = exports.isDeliverableArtifactProperty = exports.isDeliverableProperties = exports.isDeliverableProperty = exports.isReportingOutputsDocxConfig = exports.isReportingOutputsXlsxConfig = exports.isReportingOutputsXlsxDataSheetOutputs = exports.isReportingOutputsXlsxDataSheetOutput = exports.isReportingInputsIntermediateFields = exports.isReportingInputsIntermediateField = exports.isReportingInputsDataAccessors = exports.isReportingInputsDataAccessor = exports.isGlobalRecurringDateConfigs = exports.isGlobalRecurringDateConfig = exports.isReportingInputsConfig = exports.isReportingMechanics = exports.isReportingProperty = exports.isRecurringDateProperty = exports.isFinancialCovenantConfig = exports.isFinancialCovenantProperties = exports.isFinancialCovenantProperty = exports.isPortfolioCovenantProperties = exports.isPortfolioCovenantProperty = exports.isQueryVariables = exports.isQueryVariable = exports.isBaseFieldConfigArray = exports.isBaseFieldConfig = exports.isNumericType = exports.isCalcAgentMechanicsDomain = exports.typeguardErrorCreditAgreementFullArtifact = exports.isCreditAgreementFullArtifact = exports.isCreditAgreementArtifact = exports.isCreditAgreementDocument = exports.isConcentrationLimitCalculationSourceConfig = void 0;
const _ = __importStar(require("lodash"));
const schema = __importStar(require("../schema"));
const DataTapeField_1 = require("../types/CreditAgreement/DataTapeField");
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isConcentrationLimitCalculationSourceConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ConcentrationLimitSourceConfigSchema,
    typeguardName: 'isConcentrationLimitCalculationSourceConfig',
});
exports.isCreditAgreementDocument = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementDocumentSchema,
    typeguardName: 'isCreditAgreementDocument',
});
exports.isCreditAgreementArtifact = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementArtifactSchema,
    typeguardName: 'isCreditAgreementArtifact',
});
exports.isCreditAgreementFullArtifact = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementFullArtifactSchema,
    typeguardName: 'isCreditAgreementFullArtifact',
});
exports.typeguardErrorCreditAgreementFullArtifact = (0, typeguardUtils_1.typeguardErrorWrapper)({ schema: schema.CreditAgreementFullArtifactSchema });
exports.isCalcAgentMechanicsDomain = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.CalcAgentMechanicsDomainSchema,
    typeguardName: 'isCalcAgentMechanicsDomain',
});
const isNumericType = (obj, logOptions) => {
    let errorMessage = '';
    if (typeof obj !== 'string') {
        errorMessage = 'NumericType typeguard failed: input is not a string';
    }
    else if (!DataTapeField_1.DataTapeField.NumericTypes.some((type) => type === obj)) {
        errorMessage = `NumericType typeguard failed: ${obj} is not NumericType option`;
    }
    if (errorMessage && logOptions?.logger) {
        logOptions.logger({ message: errorMessage }, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return errorMessage.length === 0;
};
exports.isNumericType = isNumericType;
exports.isBaseFieldConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseFieldConfigSchema,
    typeguardName: 'isBaseFieldConfig',
});
exports.isBaseFieldConfigArray = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BaseFieldConfigsSchema,
    typeguardName: 'isBaseFieldConfigArray',
});
exports.isQueryVariable = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.QueryVariableSchema,
    typeguardName: 'isQueryVariable',
});
const isQueryVariables = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isQueryVariable)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isQueryVariables = isQueryVariables;
exports.isPortfolioCovenantProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PortfolioCovenantPropertySchema,
    typeguardName: 'isPortfolioCovenantProperty',
});
const isPortfolioCovenantProperties = (obj, logOptions) => {
    if (Array.isArray(obj) &&
        _.every(obj, (el) => (0, exports.isPortfolioCovenantProperty)(el, logOptions))) {
        return true;
    }
    return false;
};
exports.isPortfolioCovenantProperties = isPortfolioCovenantProperties;
exports.isFinancialCovenantProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinancialCovenantPropertySchema,
    typeguardName: 'isFinancialCovenantProperty',
});
exports.isFinancialCovenantProperties = (0, typeguardUtils_1.typeguardArrayFunctionLogWrapper)({
    schema: schema.FinancialCovenantPropertySchema,
    typeguardName: 'isFinancialCovenantProperties',
});
exports.isFinancialCovenantConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FinancialCovenantConfigSchema,
    typeguardName: 'isFinancialCovenantConfig',
});
exports.isRecurringDateProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.RecurringDatePropertySchema,
    typeguardName: 'isRecurringDateProperty',
});
exports.isReportingProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingPropertySchema,
    typeguardName: 'isReportingProperty',
});
exports.isReportingMechanics = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingMechanicsSchema,
    typeguardName: 'isReportingMechanics',
});
exports.isReportingInputsConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingInputsConfig,
    typeguardName: 'isReportingInputsConfig',
});
exports.isGlobalRecurringDateConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.GlobalRecurringDateConfigSchema,
    typeguardName: 'isGlobalRecurringDateConfig',
});
const isGlobalRecurringDateConfigs = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isGlobalRecurringDateConfig)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isGlobalRecurringDateConfigs = isGlobalRecurringDateConfigs;
exports.isReportingInputsDataAccessor = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingInputsDataAccessor,
    typeguardName: 'isReportingInputsDataAccessor',
});
const isReportingInputsDataAccessors = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isReportingInputsDataAccessor)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isReportingInputsDataAccessors = isReportingInputsDataAccessors;
exports.isReportingInputsIntermediateField = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingInputsIntermediateField,
    typeguardName: 'isReportingInputsIntermediateField',
});
const isReportingInputsIntermediateFields = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isReportingInputsIntermediateField)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isReportingInputsIntermediateFields = isReportingInputsIntermediateFields;
exports.isReportingOutputsXlsxDataSheetOutput = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingOutputsXlsxDataSheetOutputSchema,
    typeguardName: 'isReportingOutputsXlsxDataSheetOutput',
});
const isReportingOutputsXlsxDataSheetOutputs = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isReportingOutputsXlsxDataSheetOutput)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isReportingOutputsXlsxDataSheetOutputs = isReportingOutputsXlsxDataSheetOutputs;
exports.isReportingOutputsXlsxConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingOutputsXlsxConfigSchema,
    typeguardName: 'isReportingOutputsXlsxConfig',
});
exports.isReportingOutputsDocxConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingOutputsDocxConfigSchema,
    typeguardName: 'isReportingOutputsDocxConfig',
});
exports.isDeliverableProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.DeliverablePropertySchema,
    typeguardName: 'isDeliverableProperty',
});
const isDeliverableProperties = (obj, logOptions) => {
    if (Array.isArray(obj) &&
        _.every(obj, (el) => (0, exports.isDeliverableProperty)(el, logOptions))) {
        return true;
    }
    return false;
};
exports.isDeliverableProperties = isDeliverableProperties;
exports.isDeliverableArtifactProperty = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.DeliverableArtifactPropertySchema,
    typeguardName: 'isDeliverableArtifactProperty',
});
exports.isDeliverableArtifactPropertyConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.DeliverableArtifactPropertyConfigSchema,
    typeguardName: 'isDeliverableArtifactPropertyConfig',
});
exports.isAthenaConfigRecurringQuery = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AthenaConfigRecurringQuerySchema,
    typeguardName: 'isAthenaConfigRecurringQuery',
});
const isAthenaConfigRecurringQueries = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isAthenaConfigRecurringQuery)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isAthenaConfigRecurringQueries = isAthenaConfigRecurringQueries;
exports.isAthenaConfigQuery = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AthenaConfigQuerySchema,
    typeguardName: 'isAthenaConfigQuery',
});
const isAthenaConfigQueries = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isAthenaConfigQuery)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isAthenaConfigQueries = isAthenaConfigQueries;
exports.isDocxFileInsertionOutputs = (0, typeguardUtils_1.typeguardArrayFunctionLogWrapper)({
    schema: schema.ReportingOutputsDocxConfigSchema,
    typeguardName: 'isDocxFileInsertionOutputs',
});
exports.isDocxColumnConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingOutputsDocxColumnConfigSchema,
    typeguardName: 'isDocxColumnConfig',
});
exports.isDocxColumnConfigs = (0, typeguardUtils_1.typeguardArrayFunctionLogWrapper)({
    schema: schema.ReportingOutputsDocxColumnConfigSchema,
    typeguardName: 'isDocxColumnConfigs',
});
exports.isAttachmentRateLimitPropertySchema = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.AttachmentRateLimitPropertySchema,
    typeguardName: 'isAttachmentRateLimitPropertySchema',
});
//# sourceMappingURL=creditAgreement.js.map